type ExportStatus = {
  status?: 'pending' | 'processing' | 'failed' | 'completed';
  export_id?: string;
  message?: string;
};

type GetGruntWorxProgressCaptionsParams = {
  isPolling: boolean;
  exportStatus?: ExportStatus | null;
  pollAttempts: number;
  maxPollAttempts: number;
};

/**
 * Generates progress captions for the GruntWorx export process
 * 
 * @param params - Object containing polling state and export status information
 * @returns Array of caption strings to display during the export process
 */
export const getGruntWorxProgressCaptions = ({
  isPolling,
  exportStatus,
  pollAttempts,
  maxPollAttempts,
}: GetGruntWorxProgressCaptionsParams): string[] => {
  return [
    isPolling && exportStatus?.status === 'pending'
      ? 'Export queued for processing...'
      : 'Preparing files...',
    isPolling && exportStatus?.status === 'processing'
      ? 'Processing files...'
      : 'Uploading to GruntWorx...',
    isPolling
      ? `Checking export status: (${pollAttempts}/${maxPollAttempts})`
      : 'Processing export...',
  ];
}; 